import Contact from "../../Components/Legal/Contact";
import Cookies from "../../Components/Legal/Cookies";
import Soukromi from "../../Components/Legal/Soukromi";
import { appPages } from "../../Pages/app_pages";
import AppPage from "../../Pages/AppPage";
import CandyMath from "../../Pages/CandyMath";
import Gemstone from "../../Pages/Gemstone";
import MainPage from "../../Pages/MainPage";

export const main_routes = [{
    path: "/",
    element: <MainPage />,
},
{
    path: "*",
    element: <MainPage />,
},
{
    path: "/zasady",
    element: <Soukromi />,
},
{
    path: "/kontakt",
    element: <Contact />,
},
{
    path: "/cookies",
    element: <Cookies />,
},
...appPages.map((d) => {
    return { path: d.link, element: <AppPage appPageData={d} /> }
}),
{
    path: "/candymath",
    element: <CandyMath />,
},
{
    path: "/gemstone",
    element: <Gemstone />,
},
];